import React, { useEffect } from 'react';
import {
  Award,
  Settings,
  MapPin,
  MountainSnow,
  Clock,
  HeartHandshake
} from 'lucide-react';
import { whyChooseUs } from '../mockData';

const WhyUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-why-us">
      {/* Hero Section */}
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">Neden Vizyon Turizm?</h1>
          <p className="page-subtitle">
            Güven, kalite ve mükemmellik için seçilme nedenleri
          </p>
        </div>
      </section>

      {/* Why Choose Us Grid */}
      <section className="section">
        <div className="container">
          <div className="why-grid-full">
            {whyChooseUs.map((item, index) => {
              let IconComponent = Award;
              if (item.icon === 'settings') IconComponent = Settings;
              if (item.icon === 'map-pin') IconComponent = MapPin;
              if (item.icon === 'mountain-snow') IconComponent = MountainSnow;
              if (item.icon === 'clock') IconComponent = Clock;
              if (item.icon === 'heart-handshake') IconComponent = HeartHandshake;
              
              return (
                <div key={index} className="why-card-full">
                  <div className="why-icon-large">
                    <IconComponent size={40} />
                  </div>
                  <h2 className="why-title-large">{item.title}</h2>
                  <p className="why-desc-large">{item.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Trust Section */}
      <section className="section trust-section">
        <div className="container">
          <div className="trust-content">
            <h2 className="section-title">Güven ve Kalite Garantisi</h2>
            <p className="trust-text">
              Yıllardır Erzurum'da ailelerin ve kurumların güvenini kazanmış, 
              kalite standartlarından ödün vermeyen hizmet anlayışımızla 
              her gün binlerce kişiye güvenli taşımacılık hizmeti sunuyoruz.
            </p>
            <p className="trust-text">
              Çocuklarınızı ve personelinizi gönül rahatlığıyla emanet 
              edebileceğiniz, her detayın titizlikle takip edildiği bir 
              taşımacılık deneyimi için Vizyon Turizm'i tercih edin.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyUs;
